import React from "react";
import { Fade, Slide } from "react-awesome-reveal";
import {
  TbAlertTriangle,
  TbDatabase,
  TbClockX,
  TbRoute,
  TbPlugConnectedX,
  TbHandStop,
} from "react-icons/tb";
import "../../styles/ProblemSection.css";

const problems = [
  { icon: <TbDatabase size={22} />,       label: "Datos dispersos",          sub: "Sin una fuente única de verdad." },
  { icon: <TbClockX size={22} />,          label: "Decisiones tardías",       sub: "Reportes que llegan cuando ya es tarde." },
  { icon: <TbRoute size={22} />,           label: "Falta de trazabilidad",    sub: "No sabés qué pasó, cuándo ni por qué." },
  { icon: <TbPlugConnectedX size={22} />,  label: "Áreas desconectadas",      sub: "Cada sector habla un idioma diferente." },
  { icon: <TbHandStop size={22} />,        label: "Procesos manuales",        sub: "Tiempo y dinero perdidos en fricción operativa." },
];

const ProblemSection = () => (
  <section className="prob-root" id="problema">
    <div className="container">

      {/* Badge */}
      <Fade direction="down" triggerOnce duration={700}>
        <div className="eco-badge mx-auto mb-4">
          <TbAlertTriangle size={14} style={{ marginRight: 6 }} />
          El problema que nadie resuelve del todo
        </div>
      </Fade>

      {/* Headline */}
      <Fade direction="up" triggerOnce duration={800} delay={100}>
        <h2 className="eco-main-title text-center text-white ">
          La mayoría de las empresas crecen…{" "}
          <span className="highlight">pero sus sistemas no.</span>
        </h2>
      </Fade>

      <Fade direction="up" triggerOnce duration={700} delay={200}>
        <p className="eco-main-sub text-center text-white">
          El crecimiento sin infraestructura digital crea una brecha que se amplía
          con cada nuevo proceso, área o producto que sumás.
        </p>
      </Fade>

      {/* Problem cards */}
      <div className="prob-grid">
        {problems.map((p, i) => (
          <Slide direction="up" triggerOnce duration={600} delay={i * 80} key={p.label}>
            <div className="prob-card">
              <span className="prob-icon">{p.icon}</span>
              <div className="prob-text">
                <span className="prob-label">{p.label}</span>
                <span className="prob-sub">{p.sub}</span>
              </div>
            </div>
          </Slide>
        ))}
      </div>

      {/* Consequence callout */}
      <Fade direction="up" triggerOnce duration={700} delay={500}>
        <div className="prob-callout">
          <TbAlertTriangle size={18} className="prob-callout-icon" />
          <p>
            Cada día sin sistema integrado es un día con decisiones a ciegas,
            costos ocultos y oportunidades que se escapan.
          </p>
        </div>
      </Fade>

    </div>
  </section>
);

export default ProblemSection;
